import React from 'react';
import { useTranslation } from 'react-i18next';

import { Currency, HowToHelpType, OnlineHelp } from '@shared/enums';
import { useLanguage } from '@hooks/useLanguage';
import { useExchangeCurrency } from '@shared/hooks/useExchangeCurrency';

import { getIntegrationGoods } from '@services/integrations/goods';
import { mapLanguageToCurrency } from '@shared/utils/currencies';
import { Tooltip } from '@shared/ui/tooltips/base';

interface ApplicationOnlineAmountNoteProps {
  amount: number;

  category: HowToHelpType | OnlineHelp;
}

export const ApplicationOnlineAmountNote: React.FC<ApplicationOnlineAmountNoteProps> = ({ amount, category }) => {
  const language = useLanguage();
  const { t } = useTranslation();

  const exchangeCurrency = useExchangeCurrency();
  const fromCurrency = mapLanguageToCurrency(language);
  const exchangeRate = React.useMemo(
    () => exchangeCurrency(1, { from: fromCurrency, to: Currency.Uah, precision: 2 }),
    [exchangeCurrency, fromCurrency],
  );

  const goodsExamples = getIntegrationGoods()?.[category as OnlineHelp]?.[amount] || [];

  if (language === 'uk') return null;

  return (
    <div>
      <div className="text-xxs font-light mb-5">{t('please-note-currency', exchangeRate)}</div>

      {goodsExamples.length > 0 && (
        <div className="mb-10">
          <p className="text-xxs font-light mb-5">{t('here-list-goods')}</p>
          <div className="flex flex-wrap gap-x-3 gap-y-5 text-xl select-none">
            {goodsExamples.map((good) => {
              return (
                <Tooltip content={good.value} key={good.value}>
                  <good.label />
                </Tooltip>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};
